var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-info-box-content" },
    [
      _c(
        "div",
        { staticClass: "info as-flex flex-vertical main-start cross-start" },
        [
          _c("div", { staticClass: "company f-3" }, [
            _vm._v(
              _vm._s(
                _vm.userInfo && _vm.userInfo.name ? _vm.userInfo.name : "--"
              )
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "mobile-password as-flex main-start cross-center f-2",
            },
            [
              _c("div", { staticClass: "mobile" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.userInfo && _vm.userInfo.mobile
                        ? _vm.userInfo.mobile
                        : "未绑定手机"
                    ) +
                    "\n        (\n        "
                ),
                _c(
                  "span",
                  {
                    staticClass: "operation",
                    on: {
                      click: function ($event) {
                        return _vm.bindOrubindMobile(
                          _vm.userInfo && _vm.userInfo.mobile
                            ? "unbind"
                            : "bind"
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.userInfo && _vm.userInfo.mobile ? "解绑" : "绑定"
                      )
                    ),
                  ]
                ),
                _vm._v("\n        )\n      "),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "password operation",
                  on: {
                    click: function ($event) {
                      return _vm.changePassword("change")
                    },
                  },
                },
                [_vm._v("修改密码")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "account-grant as-flex flex-vertical main-between cross-start f-2",
            },
            [
              _c("span", [
                _vm._v(
                  "账号权限：" +
                    _vm._s(
                      _vm.userInfo && _vm.userInfo.expire_time
                        ? _vm.userInfo.expire_time
                        : "长期有效"
                    )
                ),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "账号类型：" +
                    _vm._s(
                      _vm.userInfo && _vm.userInfo.category
                        ? _vm.userInfo.category
                        : "--"
                    )
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "introduce as-flex main-around cross-center f-2" },
        [
          _c(
            "div",
            {
              staticClass:
                "introduce-func as-flex flex-vertical main-center cross-center",
              on: { click: _vm.commitRequirement },
            },
            [
              _c("img", {
                staticClass: "userinfo-img",
                attrs: {
                  src: require("../../assets/images/userinfo-requirement.png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("发起需求")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "introduce-func as-flex flex-vertical main-center cross-center",
              on: { click: _vm.introduction },
            },
            [
              _c("img", {
                staticClass: "userinfo-img",
                attrs: {
                  src: require("../../assets/images/userinfo-guide.png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("使用教程")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "introduce-func as-flex flex-vertical main-center cross-center",
              on: { click: _vm.aboutus },
            },
            [
              _c("img", {
                staticClass: "userinfo-img",
                attrs: {
                  src: require("../../assets/images/userinfo-aboutus.png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("关于我们")]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "logout as-flex main-center cross-center" }, [
        _c(
          "div",
          {
            staticClass: "louout-btn as-flex main-center cross-center",
            on: { click: _vm.logout },
          },
          [_vm._v("退出")]
        ),
      ]),
      _vm._v(" "),
      _vm.modal.visibility
        ? [
            _c(_vm.modalsMapping[_vm.modal.type], {
              tag: "component",
              attrs: { defaultConfig: _vm.modal.defaultConfig },
              on: { closeModal: _vm.closeModal },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }